import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string, array } from "yup";
import HoliDayCalenderForm from "../Layouts/HoliDayCalendarForm";
import { HoliDayCalenderFormValues } from "src/models/HoliDayCalender.model";
import { useAddHoliDayMutation } from "src/services/HolidayCalendarServices";
import { showToast } from "src/utils/showToaster";
import moment from "moment";

type Props = {
  onClose: () => void;
};

const AddHolidayCalendarFormWrapper = ({ onClose }: Props) => {
  const [addHoliDay] = useAddHoliDayMutation();

  // Form Initial Values
  const initialValues: HoliDayCalenderFormValues = {
    date: "",
    optional: false,
    allBranches: false,
    holidayName: "",
    branchId: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    date: string().required("Please enter date"),
    optional: string().required("Required"),
    holidayName: string().required("Holiday Name is Required"),
    branchId: array().required("branch  Name is Required"),
  });

  // Handle Submit
  const handleSubmit = (
    values: HoliDayCalenderFormValues,
    { setSubmitting, resetForm }: FormikHelpers<HoliDayCalenderFormValues>
  ) => {
    const myMomentObject = moment(values?.date);

    // Assuming myMomentObject is your Moment.js object
    const date = myMomentObject.date(); // Day of the month
    const month = myMomentObject.format("MMMM"); // Month (0-indexed, so January is 0)
    const year = myMomentObject.year(); // Full year

    const formattedValues = { 
      allBranches: values?.allBranches,
      holidayName: values?.holidayName,
      branchId: values?.branchId?.map((branch: any) => branch?.value),
      date: date.toString(),
      month: month.toString(),
      year: year.toString(),
      optional: values?.optional,
    };
    addHoliDay(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <HoliDayCalenderForm formType='ADD' formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddHolidayCalendarFormWrapper;
